
/*
 * Map toolbar for truth strip drawing (part of Planting Rx). This borrows *heavily*
 * from the core DrawToolbar (which is oriented towards more detailed drawing tools,
 * like field and managemnet zone editing).
 *
 * Maybe at some point, a base class could be derived that would simplify both toolbar
 * classes.
 *
 */

(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  exports.TruthStripToolbar = (function(superClass) {
    extend(TruthStripToolbar, superClass);

    function TruthStripToolbar() {
      this.disableCurrent = bind(this.disableCurrent, this);
      this.activate = bind(this.activate, this);
      this._polySelected = bind(this._polySelected, this);
      this.handleDrawComplete = bind(this.handleDrawComplete, this);
      this._anyButtonPressed = bind(this._anyButtonPressed, this);
      this.startDrawStrip = bind(this.startDrawStrip, this);
      TruthStripToolbar.include(L.Mixin.Events);
      this.drawMode = ko.observable('inactive');
      this.currentTool = ko.observable();
      this.dontReenableDraw = false;
      this.lastClicked = ko.observable();
      this.prevClicked = ko.observable();
      this.orig_options = this.initShapeDefaults();
      this.drawnOptions = this.orig_options.shape;
      this.drawControlOptions = {
        position: 'topleft',
        draw: {
          style: {
            color: '#008161',
            width: 3
          },
          rectangle: {
            shapeOptions: this.orig_options.shape
          }
        },
        finished: {
          style: {
            'fillOpacity': 0.6,
            'weight': 2,
            'color': '#0F0'
          }
        },
        colors: {
          style: (function(_this) {
            return function(mode) {
              if (_this.mode === 'add') {
                return {
                  color: '#008000',
                  width: 3
                };
              }
              if (_this.mode === 'subtract') {
                return {
                  color: '#FF0000',
                  width: 3
                };
              }
            };
          })(this)
        },
        toolbars: [
          {
            rows: [
              [
                {
                  name: 'draw-rect-add',
                  html: '<i class="drawicon-rect-green"></i>',
                  toggle: true
                }
              ]
            ]
          }
        ]
      };
      this.events = new L.MassEvents();
    }

    TruthStripToolbar.prototype.init = function() {
      this.drawControl = new L.Control.MfDraw();
      this.drawControl.options = this.drawControlOptions;
      if (this.drawnItems == null) {
        this.initDrawnItems();
      } else {
        App.map.addLayer(this.drawnItems);
      }
      App.map.addControl(this.drawControl);
      return this.initListeners();
    };

    TruthStripToolbar.prototype.initShapeDefaults = function() {
      var editOpts, shapeOpts;
      shapeOpts = {
        fillColor: '#0066FF',
        color: '#0033FF',
        opacity: 0.75,
        weight: 2,
        fillOpacity: 0.6
      };
      editOpts = $.extend(shapeOpts, {
        color: '#0033FF',
        fillOpacity: 0.6,
        guidelineDistance: 20
      });
      return {
        shape: shapeOpts,
        edit: editOpts
      };
    };

    TruthStripToolbar.prototype.initListeners = function() {
      var self;
      self = this;
      App.map.on('draw:created', this.handleDrawComplete);
      return this.drawControl.addCallback('*', this._anyButtonPressed);
    };

    TruthStripToolbar.prototype.initDrawnItems = function() {
      this.drawnItems = new L.FeatureGroup();
      return App.map.addLayer(this.drawnItems);
    };

    TruthStripToolbar.prototype.startDrawStrip = function() {
      this._anyButtonPressed({}, 'draw-rect-add');
      this.currentTool(new L.Draw.Rectangle(App.map, this.drawControl.options.draw.rectangle));
      this.currentTool().enable();
      return this.drawMode('draw');
    };

    TruthStripToolbar.prototype._anyButtonPressed = function(e, name) {
      this._setStyles();
      if ((this.currentTool() != null) && (this.currentTool().disable != null)) {
        this.currentTool().disable();
      }
      this.prevClicked(this.lastClicked());
      return this.lastClicked(name);
    };

    TruthStripToolbar.prototype.handleDrawComplete = function(e) {
      var layer, self, type;
      self = this;
      type = e.layerType;
      layer = e.layer;
      L.GeoUtil.unnestAdd(this.drawnItems, layer);
      this.drawMode('inactive');
      this._setStyles();
      return this.fire('toolbar:shape-added');
    };

    TruthStripToolbar.prototype._polySelected = function(e) {
      var handler;
      this.drawMode('edit');
      handler = new L.Edit.PolyWithHoles(e.layer);
      handler.enable();
      this.fire('select:poly-selected');
      if ((this.currentTool().h != null) && (this.currentTool().h.disable != null)) {
        this.currentTool().h.disable();
      }
      return this.currentTool().h = handler;
    };


    /*
     * activate: (name) -> null
     *     - name (string): name of the button to activate
     *
     * Allow you to programmatically activate a button by name
     */

    TruthStripToolbar.prototype.activate = function(name) {
      var btn;
      btn = this.drawControl.getButton(name);
      if (btn != null) {
        return this.drawControl.handleClick(name);
      }
    };

    TruthStripToolbar.prototype._setStyles = function(style) {
      if (style == null) {
        style = this.drawnOptions;
      }
      return this.drawnItems.eachLayer(function(l) {
        if (l.setStyle != null) {
          return l.setStyle(style);
        }
      });
    };

    TruthStripToolbar.prototype.destroy = function() {
      if (this.drawControl) {
        App.map.removeControl(this.drawControl);
        this.drawControl = null;
      }
      if ((this.currentTool() != null) && (this.currentTool().disable != null)) {
        this.currentTool().disable();
      }
      App.map.off('draw:created', this.handleDrawComplete);
      if (this.drawnItems) {
        return App.map.removeLayer(this.drawnItems);
      }
    };

    TruthStripToolbar.prototype.disableCurrent = function() {
      var ref;
      if ((ref = this.currentTool()) != null) {
        if (typeof ref.disable === "function") {
          ref.disable();
        }
      }
      return this.currentTool(null);
    };

    TruthStripToolbar.prototype.getAreas = function(pusharray, start) {
      if (pusharray == null) {
        pusharray = [];
      }
      if (start == null) {
        start = this.drawnItems;
      }
      if (!start) {
        return [];
      }
      start.eachLayer((function(_this) {
        return function(layer) {
          if (layer instanceof L.FeatureGroup) {
            return _this.getAreas(pusharray, layer);
          } else {
            return pusharray.push(layer);
          }
        };
      })(this));
      return pusharray;
    };

    return TruthStripToolbar;

  })(L.Class);

}).call(this);
